const runtimeSettings = typeof window !== "undefined" ? window.pcaSettings || {} : {};

const sanitizeBaseUri = (value) => (value || "").replace(/\/+$/, "");
const normalizeAuthMode = (value) =>
  (value || "").toLowerCase() === "internal" ? "internal" : "external";

const defaultApiBase =
  process.env.REACT_APP_API_BASE ||
  runtimeSettings?.api?.uri ||
  "https://pca-transcripts-worker.insurancenavy.workers.dev";

const sanitizedApiBase = sanitizeBaseUri(defaultApiBase);
const resolvedAuthMode = normalizeAuthMode(
  runtimeSettings?.auth?.mode || process.env.REACT_APP_AUTH_MODE
);

const mergedConfig = {
  ...runtimeSettings,
  api: {
    uri: sanitizedApiBase,
    pageSize:
      Number(process.env.REACT_APP_API_PAGE_SIZE) ||
      runtimeSettings?.api?.pageSize ||
      1000,
  },
  auth: runtimeSettings?.auth,
  authMode: resolvedAuthMode,
  genai: runtimeSettings?.genai || { query: false },
};

if (typeof window !== "undefined") {
  window.pcaSettings = mergedConfig;
}

export const API_BASE = mergedConfig.api.uri;
export const AUTH_MODE = mergedConfig.authMode;
export const AUTH_ENABLED =
  AUTH_MODE === "internal" ||
  (AUTH_MODE === "external" &&
    Boolean(mergedConfig.auth?.uri && mergedConfig.auth?.clientId));

export default mergedConfig;
